import React, { useEffect, useState, useCallback } from "react";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import Moment from "react-moment";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../store/auth";
import { getFilterAllCandidates } from "../store/candidate";
import { useLoadCandidatesByFilterMutation } from "../store/candidateApiSlice";
import RateEncryptDecrypt from "../../Services/RateEncryptDecrypt";

const CANDIDATE_INFO_STYLES = {
    shell: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        borderRadius: "0",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    hero: {
        padding: "16px 20px",
        background: "#ffffff",
        borderBottom: "1px solid #e2e8f0",
        display: "flex",
        alignItems: "center"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        gap: "16px",
        flexWrap: "wrap",
        alignItems: "center",
        width: "100%"
    },
    heroCopy: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: "220px",
        flex: 1
    },
    avatarBadge: {
        width: "44px",
        height: "44px",
        borderRadius: "0",
        background: "#0f172a",
        color: "#ffffff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: 600,
        boxShadow: "0 8px 18px rgba(0, 0, 0, 0.15)"
    },
    title: {
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: 1.2,
        color: "#0f172a",
        margin: 0,
        letterSpacing: "-0.01em"
    },
    subtitle: {
        fontSize: "12px",
        color: "#64748b",
        margin: 0
    },
    badgeRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center"
    },
    badge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "9px 18px",
        borderRadius: "0",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(203, 213, 225, 0.85)",
        fontSize: "13px",
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        whiteSpace: "nowrap"
    },
    badgeIcon: {
        color: "#0f172a",
        fontSize: "13px"
    },
    badgeLabel: {
        color: "#64748b",
        fontWeight: 600
    },
    badgeValue: {
        color: "#0f172a",
        fontWeight: 600
    },
    toggleButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        whiteSpace: "nowrap",
        cursor: "pointer",
        outline: "none",
        transition: "all 0.2s ease"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
        gap: "12px",
        padding: "16px"
    },
    card: {
        backgroundColor: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        borderRadius: "0",
        padding: "14px",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.03)",
        transition: "all 0.2s ease"
    },
    cardInner: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px"
    },
    cardIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "0",
        backgroundColor: "#f1f5f9",
        color: "#0f172a",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        border: "1px solid #e2e8f0",
        flexShrink: 0
    },
    cardContent: {
        flex: 1,
        minWidth: 0
    },
    cardLabel: {
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "6px"
    },
    primaryText: {
        fontSize: "15px",
        fontWeight: 600,
        lineHeight: 1.3,
        color: "#0f172a",
        marginBottom: "4px",
        overflowWrap: "break-word"
    },
    secondaryText: {
        fontSize: "12.5px",
        lineHeight: 1.45,
        color: "#475569",
        marginBottom: "3px",
        overflowWrap: "break-word"
    },
    contactLine: {
        display: "flex",
        alignItems: "flex-start",
        gap: "6px",
        fontSize: "12.5px",
        lineHeight: 1.45,
        color: "#475569",
        marginBottom: "3px"
    },
    contactLineIcon: {
        marginTop: "2px",
        flexShrink: 0
    },
    contactLineText: {
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    truncate: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    durationSummary: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "6px 12px",
        borderRadius: "0",
        background: "#f1f5f9",
        color: "#0f172a",
        fontSize: "12px",
        fontWeight: 600,
        marginBottom: "10px"
    },
    durationTimeline: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        paddingLeft: "16px"
    },
    durationLine: {
        position: "absolute",
        left: "5px",
        top: "6px",
        bottom: "6px",
        width: "2px",
        background: "#cbd5e1"
    },
    durationRow: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px"
    },
    durationDot: {
        position: "absolute",
        left: "-16px",
        top: "5px",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#0f172a",
        boxShadow: "0 0 0 3px #e2e8f0"
    },
    durationLabel: {
        fontSize: "10px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#64748b"
    },
    durationDate: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#0f172a"
    },
    emptyText: {
        fontSize: "13px",
        color: "#94a3b8",
        margin: 0
    }
};

export default function CandidateInfo() {
    const [candidate, setCandidate] = useState(null);
    const [entityType, setEntityType] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const candidateSelector = useSelector(getFilterAllCandidates);
    const currentUser = getCurrentUser();
    const currentUserId = currentUser?.id;

    const [loadCandidatesByFilterMut] = useLoadCandidatesByFilterMutation();

    const getCandidateDetails = useCallback((id) => {
        const frmBody = new FormData();
        frmBody.append("id", id);
        frmBody.append("name", "");
        frmBody.append("email", "");
        frmBody.append("entity", "");
        frmBody.append("type", "candidate");
        frmBody.append("filterType", "single");
        loadCandidatesByFilterMut(frmBody);
    }, [loadCandidatesByFilterMut]);

    useEffect(() => {
        if (currentUserId) {
            getCandidateDetails(currentUserId);
        }
    }, [currentUserId, getCandidateDetails]);

    useEffect(() => {
        if (candidateSelector.length > 0) {
            setCandidate(candidateSelector[0]);
            const entType = getFieldData(candidateSelector[0].performerData, "candidateonboardingform", "CandidateEntity");
            setEntityType(entType);
        }
    }, [candidateSelector]);

    let item = "";
    if (candidate) item = candidate;

    const positionTitle = candidate ? getFieldData(candidate.performerData, "projectengagement", "PositionTitle") : "";
    const agencyName = candidate ? getFieldData(candidate.performerData, "projectengagement", "AgencyName") : "";
    const mspMode = candidate ? getFieldData(candidate.performerData, "candidateonboardingform", "Msp_Mode") : "";
    const w9Type = candidate ? getFieldData(candidate.performerData, "candidateonboardingform", "w9_Type") : "";
    const showRate = entityType === "1099 Basis" || entityType === "W2 Basis";
    const hasRecruiter = candidate && (item.recruiter?.label || item.recruiter?.fuid);

    const candidateName = candidate ? `${item.performername || ""} ${item.lastName || ""}`.trim() : "Candidate Information";
    const firstLetter = candidateName.charAt(0).toUpperCase() || "C";

    const renderRateDetails = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Compensation details loading...</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.primaryText}>{entityType ? entityType.replace("Basis", "").trim() : "Entity type not specified"}</div>
            {positionTitle && <div style={{ ...CANDIDATE_INFO_STYLES.secondaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={positionTitle}>{positionTitle}</div>}
            {entityType === "W2 Basis" && w9Type && <div style={{ ...CANDIDATE_INFO_STYLES.secondaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={w9Type}>{w9Type}</div>}
        </>;
    };

    const renderSubcontractor = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Subcontractor info loading...</p>;
        }

        if (entityType !== "C2C Basis") {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Not applicable for this entity type.</p>;
        }

        return <>
            <div style={{ ...CANDIDATE_INFO_STYLES.primaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={item.subcontractor?.label || "No subcontractor on file."}>{item.subcontractor?.label || "No subcontractor on file."}</div>
            <div style={CANDIDATE_INFO_STYLES.secondaryText}>ID: {item.validId || "--"}</div>
            <div style={{ ...CANDIDATE_INFO_STYLES.secondaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={item.subcontractor?.email || "No email on file."}>{item.subcontractor?.email || "No email on file."}</div>
        </>;
    };

    const renderRecruiter = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Recruiter info loading...</p>;
        }

        return <>
            <div style={{ ...CANDIDATE_INFO_STYLES.primaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={item.recruiter?.label || "No recruiter on file."}>{item.recruiter?.label || "No recruiter on file."}</div>
            <div style={{ ...CANDIDATE_INFO_STYLES.secondaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={item.recruiter?.email || "No email on file."}>{item.recruiter?.email || "No email on file."}</div>
        </>;
    };

    const renderAgency = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Agency information loading...</p>;
        }

        if (!agencyName) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Not applicable.</p>;
        }

        return <>
            <div style={{ ...CANDIDATE_INFO_STYLES.primaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={agencyName}>{agencyName}</div>
            <div style={{ ...CANDIDATE_INFO_STYLES.secondaryText, ...CANDIDATE_INFO_STYLES.truncate }} title={mspMode || "MSP mode not provided."}>{mspMode || "MSP mode not provided."}</div>
        </>;
    };

    const renderDuration = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Duration details loading...</p>;
        }

        if (!item.duration) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>No project duration on file.</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.durationSummary}>
                <span><i className="fa fa-hourglass-half" style={{ marginRight: "8px" }} aria-hidden="true"></i>{item.duration.duration} Month(s)</span>
            </div>
            <div style={CANDIDATE_INFO_STYLES.durationTimeline}>
                <span style={CANDIDATE_INFO_STYLES.durationLine} aria-hidden="true"></span>
                <div style={CANDIDATE_INFO_STYLES.durationRow}>
                    <span style={CANDIDATE_INFO_STYLES.durationDot} aria-hidden="true"></span>
                    <span style={CANDIDATE_INFO_STYLES.durationLabel}>Start</span>
                    <span style={CANDIDATE_INFO_STYLES.durationDate}>
                        <Moment format="MMM Do YYYY">{item.duration.startDate}</Moment>
                    </span>
                </div>
                <div style={CANDIDATE_INFO_STYLES.durationRow}>
                    <span style={CANDIDATE_INFO_STYLES.durationDot} aria-hidden="true"></span>
                    <span style={CANDIDATE_INFO_STYLES.durationLabel}>End</span>
                    <span style={CANDIDATE_INFO_STYLES.durationDate}>
                        {item.duration.endDate ? <Moment format="MMM Do YYYY">{item.duration.endDate}</Moment> : "--"}
                    </span>
                </div>
            </div>
        </>;
    };

    return <React.Fragment>
        <style>{`
            .candidate-info-card:hover {
                transform: translateY(-2px);
                border-color: rgba(191, 219, 254, 0.9) !important;
                box-shadow: 0 10px 25px rgba(37, 99, 235, 0.07) !important;
            }
        `}</style>
        <div style={CANDIDATE_INFO_STYLES.shell}>
            <div style={CANDIDATE_INFO_STYLES.hero}>
                <div style={CANDIDATE_INFO_STYLES.heroRow}>
                    <div style={CANDIDATE_INFO_STYLES.heroCopy}>
                        <div style={CANDIDATE_INFO_STYLES.avatarBadge}>
                            {firstLetter}
                        </div>
                        <div>
                            <h2 style={CANDIDATE_INFO_STYLES.title}>{candidateName}</h2>
                            <p style={CANDIDATE_INFO_STYLES.subtitle}>
                                Candidate Profile & Engagement Details
                            </p>
                        </div>
                    </div>
                    <div style={CANDIDATE_INFO_STYLES.badgeRow}>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-id-badge" style={CANDIDATE_INFO_STYLES.badgeIcon} aria-hidden="true"></i>
                            <span style={CANDIDATE_INFO_STYLES.badgeLabel}>Candidate #:</span>
                            <span style={CANDIDATE_INFO_STYLES.badgeValue}>{candidate ? item.performerid : "--"}</span>
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-credit-card" style={CANDIDATE_INFO_STYLES.badgeIcon} aria-hidden="true"></i>
                            <span style={CANDIDATE_INFO_STYLES.badgeLabel}>IPCS ID:</span>
                            <span style={CANDIDATE_INFO_STYLES.badgeValue}>{candidate ? item.maxloans : "--"}</span>
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-money" style={CANDIDATE_INFO_STYLES.badgeIcon} aria-hidden="true"></i>
                            <span style={CANDIDATE_INFO_STYLES.badgeLabel}>Rate:</span>
                            <span style={CANDIDATE_INFO_STYLES.badgeValue}>{candidate && showRate ? (item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr") : "--"}</span>
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-calendar" style={CANDIDATE_INFO_STYLES.badgeIcon} aria-hidden="true"></i>
                            <span style={CANDIDATE_INFO_STYLES.badgeLabel}>Registered:</span>
                            <span style={CANDIDATE_INFO_STYLES.badgeValue}>{candidate ? <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment> : "--"}</span>
                        </span>
                        <button
                            type="button"
                            className="btn btn-sm"
                            style={CANDIDATE_INFO_STYLES.toggleButton}
                            onClick={() => setShowDetails(!showDetails)}
                            title={showDetails ? "Hide Details" : "Show Details"}
                        >
                            <i className={`fa ${showDetails ? "fa-chevron-up" : "fa-chevron-down"}`} aria-hidden="true"></i>
                            <span>{showDetails ? "Hide Details" : "Show Details"}</span>
                        </button>
                    </div>
                </div>
            </div>

            {showDetails && (
                <div style={CANDIDATE_INFO_STYLES.grid}>
                    <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                        <div style={CANDIDATE_INFO_STYLES.cardInner}>
                            <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-user" aria-hidden="true"></i></span>
                            <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                <div style={CANDIDATE_INFO_STYLES.cardLabel}>Candidate Contact</div>
                                {candidate ? <>
                                    <div style={CANDIDATE_INFO_STYLES.contactLine}>
                                        <i className="fa fa-envelope-o text-muted" style={CANDIDATE_INFO_STYLES.contactLineIcon}></i>
                                        <span style={CANDIDATE_INFO_STYLES.contactLineText} title={item.performeremail || "No email on file."}>{item.performeremail || "No email on file."}</span>
                                    </div>
                                    <div style={CANDIDATE_INFO_STYLES.contactLine}>
                                        <i className="fa fa-phone text-muted" style={CANDIDATE_INFO_STYLES.contactLineIcon}></i>
                                        <span style={CANDIDATE_INFO_STYLES.contactLineText} title={item.contactNo ? getFormatedNumber(item.contactNo) : "No phone on file."}>{item.contactNo ? getFormatedNumber(item.contactNo) : "No phone on file."}</span>
                                    </div>
                                </> : <p style={CANDIDATE_INFO_STYLES.emptyText}>Candidate details loading...</p>}
                            </div>
                        </div>
                    </div>

                    <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                        <div style={CANDIDATE_INFO_STYLES.cardInner}>
                            <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-briefcase" aria-hidden="true"></i></span>
                            <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                <div style={CANDIDATE_INFO_STYLES.cardLabel}>Entity & Role</div>
                                {renderRateDetails()}
                            </div>
                        </div>
                    </div>

                    {entityType === "C2C Basis" && (
                        <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                            <div style={CANDIDATE_INFO_STYLES.cardInner}>
                                <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-building-o" aria-hidden="true"></i></span>
                                <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Subcontractor</div>
                                    {renderSubcontractor()}
                                </div>
                            </div>
                        </div>
                    )}

                    {hasRecruiter && (
                        <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                            <div style={CANDIDATE_INFO_STYLES.cardInner}>
                                <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-user-plus" aria-hidden="true"></i></span>
                                <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Recruiter</div>
                                    {renderRecruiter()}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                        <div style={CANDIDATE_INFO_STYLES.cardInner}>
                            <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-sitemap" aria-hidden="true"></i></span>
                            <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                <div style={CANDIDATE_INFO_STYLES.cardLabel}>Agency / MSP</div>
                                {renderAgency()}
                            </div>
                        </div>
                    </div>

                    <div className="candidate-info-card" style={CANDIDATE_INFO_STYLES.card}>
                        <div style={CANDIDATE_INFO_STYLES.cardInner}>
                            <span style={CANDIDATE_INFO_STYLES.cardIcon}><i className="fa fa-calendar-check-o" aria-hidden="true"></i></span>
                            <div style={CANDIDATE_INFO_STYLES.cardContent}>
                                <div style={CANDIDATE_INFO_STYLES.cardLabel}>Engagement Term</div>
                                {renderDuration()}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </React.Fragment>;
}
